import React from "react";

function CompIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3307_7053)">
        <g clipPath="url(#clip1_3307_7053)">
          <path
            d="M8.36523 9.3524H11.5757M8.36523 6.19592H11.5757M11.5757 16.4545V14.0871C11.5757 13.6685 11.4066 13.2671 11.1055 12.9711C10.8045 12.6752 10.3962 12.5089 9.97047 12.5089C9.54474 12.5089 9.13644 12.6752 8.8354 12.9711C8.53436 13.2671 8.36523 13.6685 8.36523 14.0871V16.4545"
            stroke="#424242"
            strokeWidth="1.75602"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.15482 7.77434H3.54958C3.12384 7.77434 2.71554 7.94062 2.4145 8.2366C2.11346 8.53258 1.94434 8.93401 1.94434 9.35258V14.8764C1.94434 15.295 2.11346 15.6964 2.4145 15.9924C2.71554 16.2884 3.12384 16.4547 3.54958 16.4547H16.3915C16.8172 16.4547 17.2255 16.2884 17.5266 15.9924C17.8276 15.6964 17.9967 15.295 17.9967 14.8764V6.98522C17.9967 6.56665 17.8276 6.16522 17.5266 5.86924C17.2255 5.57326 16.8172 5.40698 16.3915 5.40698H14.7863"
            stroke="#424242"
            strokeWidth="1.75602"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.15479 16.4549V3.82897C5.15479 3.4104 5.32391 3.00897 5.62495 2.71299C5.92599 2.41701 6.33429 2.25073 6.76003 2.25073H13.181C13.6067 2.25073 14.015 2.41701 14.3161 2.71299C14.6171 3.00897 14.7862 3.4104 14.7862 3.82897V16.4549"
            stroke="#424242"
            strokeWidth="1.75602"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3307_7053">
          <rect width="20" height="20" fill="white" />
        </clipPath>
        <clipPath id="clip1_3307_7053">
          <rect
            width="18.0588"
            height="17.0556"
            fill="white"
            transform="translate(0.941406 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CompIcon;
